import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { Marchio } from 'my-lib-sanfelici';
import { Blobs } from 'my-lib-sanfelici';
import { MarchiService } from 'my-lib-sanfelici';




@Component({
  selector: 'app-marchi-details',
  templateUrl: './marchi-details.component.html',
  styleUrls: ['./marchi-details.component.css']
})
export class MarchiDetailsComponent implements OnInit {
id:string;
urlimage: Observable<string>;
marchio:Observable<Marchio>;
blobs:Observable<Blobs[]>;
  constructor(
    private storage:AngularFireStorage,
    private router: Router,
    private db:AngularFirestore,
              private route: ActivatedRoute,
              private marchiservice: MarchiService) { }
              onDelete(item:Blobs){
                item.refFirestore.delete().then(()=>{
                  this.storage.ref(item.fullPath).delete();
                });
//this.storage.ref(item.fullPath).delete()
              }
  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.marchio = this.marchiservice.get(this.id);
    this.blobs= this.db.collection('marchi')
    .doc(this.id)
    .collection<Blobs>('blobs', ref => ref.orderBy('id').where('type', '==', 'marchi'))
.valueChanges();
  }

}
